"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.importData = void 0;
const pile_class_1 = require("./pile.class");
const sector_class_1 = require("./sector.class");
function importData(data, db) {
    return __awaiter(this, void 0, void 0, function* () {
        const piles = [];
        const sectors = [];
        for (const pileOrSector of data) {
            if (/^s:\d+$/.test(pileOrSector._id)) {
                sectors.push(new sector_class_1.Sector(pileOrSector));
            }
            else {
                piles.push(new pile_class_1.Pile(pileOrSector));
            }
        }
        for (const sector of sectors) {
            let sexist = true;
            try {
                yield db.get(sector.uid);
            }
            catch (E) {
                sexist = false;
            }
            if (!sexist) {
                try {
                    yield db.put(sector.toDoc());
                }
                catch (E) {
                    console.error(E);
                    console.log(sector);
                }
            }
        }
        for (const pile of piles) {
            let pexist = true;
            try {
                yield db.get(pile.uid);
            }
            catch (E) {
                pexist = false;
            }
            if (!pexist) {
                console.log('no exists', pile.uid);
                try {
                    yield db.put(pile.toDoc());
                }
                catch (E) {
                    console.error(E);
                    console.log(pile);
                }
            }
            else {
                console.log('exists', pile.uid);
            }
        }
    });
}
exports.importData = importData;
